import { userConstants } from './../constants/user.constants';

const initialState = {};

export function uploadFile(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPLOAD_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPLOAD_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPLOAD_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}